export const isWindowAvailable = typeof window !== 'undefined';
